import { Prop } from '@app/shared/decorators/prop.decorator';
import { LotContractTypeEnumId } from '@classictechsolutions/hubapi-transpiled-enums';
import { exportDto } from '@app/shared/logic-utils/export-dto.util';
import { ILeadSearchDto } from '../interfaces/i.lead-search.dto';

class LeadSearchDto implements ILeadSearchDto {
    @Prop public id: number;
    @Prop public name: string;
    @Prop public status: string;
    @Prop public buildingConsultant: string;
    @Prop public buildingConsultantId: string;
    @Prop public callbackDate: string;
    @Prop public rawCallbackDate: string;
    @Prop public qualifiedDate: string;
    @Prop public businessEntitities: number[];
    @Prop public contractType: LotContractTypeEnumId;
    @Prop public updatedDate: string;
    @Prop public createdDate: string;
}

export const leadSearchDto = exportDto<ILeadSearchDto>(LeadSearchDto);
